import React from 'react';
import styles from './ManagerInsuranceCompaniesCaseTypesSubMenu.module.scss';
import DropdownButton from '../../../../../../Components/Button/DropdownButton';
import ManagerInsuranceCompaniesCaseTypesImport from '../ManagerInsuranceCompaniesCaseTypesImport/ManagerInsuranceCompaniesCaseTypesImport';
import NavigationButton from '../../../../../../Components/Button/NavigationButton';
import Text from '../../../../../../Components/Base/Text/Text';

interface Props {
	defaultAction: () => void;
	reloadData: () => void;
}

const ManagerInsuranceCompaniesCaseTypesSubMenu = ({
	defaultAction,
	reloadData,
}: Props) => {
	return (
		<div className={styles.wrapper}>
			<NavigationButton active={true}>
				<Text tx={'component.caseType.toCaseTypesTableButton'} />
			</NavigationButton>
			<DropdownButton title='component.caseType.toCaseTypesImportButton'>
				<ManagerInsuranceCompaniesCaseTypesImport
					defaultAction={defaultAction}
					reloadData={reloadData}
				/>
			</DropdownButton>
		</div>
	);
};

export default ManagerInsuranceCompaniesCaseTypesSubMenu;
